export default (urlPath) => {
  window.location.href = (urlPath);
};
